export default "__VITE_ASSET__BltmMG$e__";